












import { Component, Vue } from 'vue-property-decorator';
import LocaleService from '@/services/LocaleService';
import GameLogic from "../services/GameLogic";
import Animations from "../services/Animations";

@Component({
    computed: {
        welcomeText():string {
            return LocaleService.getValue(this.$store.state, "algemeen.tutorial.tip0.text");
        },
        skipLabel():string {
            return LocaleService.getValue(this.$store.state, "algemeen.introductie.startexperience.title");
        }
    },
    methods: {
        handleSkip():void {
            Animations.fadeOut(this.$el).then(() => this.$router.push('/morning/0'));
        }
    }
})
export default class Welcome extends Vue {}
